/**
 * Trigger trackEvent
 * @param event
 * @param parametername_1
 * @param parametervalue_1
 * @param parametername_2
 * @param parametervalue_2
 * @param parametername_3
 * @param parametervalue_3
 * @param parametername_4
 * @param parametervalue_4
 * @param parametername_5
 * @param parametervalue_5
 */
export function triggerTrackEvent(
	event = "",
	parametername_1 = "",	parametervalue_1 = "",
	parametername_2 = "",	parametervalue_2 = "",
	parametername_3 = "",	parametervalue_3 = "",
	parametername_4 = "",	parametervalue_4 = "",
	parametername_5 = "",	parametervalue_5 = "",
){
	if(window.dataLayer) {
		window.dataLayer.push({
			'event': 'trackEvent',
			'eventname': event,
			'parametername_1' : parametername_1,
			'parametervalue_1': parametervalue_1,
			'parametername_2' : parametername_2,
			'parametervalue_2': parametervalue_2,
			'parametername_3' : parametername_3,
			'parametervalue_3': parametervalue_3,
			'parametername_4' : parametername_4,
			'parametervalue_4': parametervalue_4,
			'parametername_5' : parametername_5,
			'parametervalue_5': parametervalue_5,
		})
	}
}